const createAccountModel = {
  formId: 'createAccountForm',
  formField: {
    createAccountName: {
      name: 'createAccountName',
      label: 'Name',
      required: true,
      requiredErrorMsg: 'Users name is required',
      invalidErrorMsg: 'Invalid name',
    },
    createAccountEmail: {
      name: 'createAccountEmail',
      label: 'Email address',
      required: true,
      requiredErrorMsg: 'Email address is required',
      invalidErrorMsg: 'Invalid email address',
    },
    createAccountPass: {
      name: 'createAccountPass',
      label: 'Password',
      required: true,
      requiredErrorMsg: 'Password is required',
      invalidErrorMsg: 'Password must be at least 8 characters',
    },
  },
  initialValues: {
    createAccountName: '',
    createAccountEmail: '',
    createAccountPass: '',
  },
};

export type createAccountModelType = {
  createAccountName: string;
  createAccountEmail: string;
  createAccountPass: string;
};

export default createAccountModel;
